import { GenericTableHead } from '../common';
import { EnhancedTableHeadProps } from '../ValuationsTable.types';

const ValuationsTableHead = ({
  order,
  orderBy,
  onRequestSort,
  columns,
}: EnhancedTableHeadProps) => (
  <GenericTableHead
    order={order}
    orderBy={orderBy}
    onRequestSort={onRequestSort}
    columns={columns}
  />
);

export default ValuationsTableHead;
